module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_f_leucistic.94ef7044.png";